import { render } from "./WatchlistView.vue?vue&type=template&id=b6e344fc&scoped=true"
import script from "./WatchlistView.vue?vue&type=script&lang=js"
export * from "./WatchlistView.vue?vue&type=script&lang=js"

import "./WatchlistView.vue?vue&type=style&index=0&id=b6e344fc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6e344fc"]])

export default __exports__